import type { ExchangeMessage } from '@repo/common/types/Exchange';
import type { SummarySection } from '@repo/common/types/Summary';
import { writable } from 'svelte/store';

export const chatServiceSections = writable<SummarySection[]>([]);
export const chatServiceHistory = writable<ExchangeMessage[]>([]);
export const chatServiceIsLoading = writable<boolean>(false);
